/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_S3_CapInputs */

const en_funnel_ob_welcome_s3_cap = /** @type {(inputs: Funnel_Ob_Welcome_S3_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen and follow along, 2 to 3x faster.`)
};

const es_funnel_ob_welcome_s3_cap = /** @type {(inputs: Funnel_Ob_Welcome_S3_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha y sigue el texto, 2 o 3 veces más rápido.`)
};

/**
* | output |
* | --- |
* | "Listen and follow along, 2 to 3x faster." |
*
* @param {Funnel_Ob_Welcome_S3_CapInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_s3_cap = /** @type {((inputs?: Funnel_Ob_Welcome_S3_CapInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_S3_CapInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_s3_cap(inputs)
	return en_funnel_ob_welcome_s3_cap(inputs)
});